import { parseCookies } from '@/helper'

export default {
  getData (state) {
    return state.data
  },
  getFullName (state) {
    return state.data.name
      ? `${state.data.name} ${state.data.surname}`
      : ''
  },
  getInitials (state) {
    return state.data?.name
      ? `${state.data?.name?.[0]}${state.data?.surname?.[0]}`.toUpperCase()
      : ''
  },
  isAuth (state) {
    return Boolean(state.data?.id || parseCookies()?.userId || '')
  },
  isSeller (state) {
    return state.data?.role?.includes('seller')
  },
  getUserId (state) {
    return state.data?.id || parseCookies()?.userId || ''
  },
  getUserRole (state) {
    return state.data?.role || []
  }
}